// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as MarkdownQuoteExtended } from '../../../assets/icons/extended/markdown/markdown-quote.svg?react';
import { createIcons } from '../../Icon';
const MarkdownQuoteIcon = /* @__PURE__ */ createIcons('MarkdownQuote', {
    extended: MarkdownQuoteExtended
});
MarkdownQuoteIcon.supportedTypes = ['extended'];
MarkdownQuoteIcon.category = 'markdown';
export default MarkdownQuoteIcon;
